export const CTA_BUTTON = 'cta-button';
